import { render, staticRenderFns } from "./PackageCardV2.vue?vue&type=template&id=0743c386&scoped=true&"
import script from "./PackageCardV2.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PackageCardV2.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PackageCardV2.vue?vue&type=style&index=0&id=0743c386&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0743c386",
  null
  
)

export default component.exports